import React from 'react';
import { BookOpen, MessageCircleHeart, Activity, Clock, ShieldAlert } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-brand-gold" data-id="element-109" />,
    title: 'The Reconciliation Roadmap eBook',
    description: 'A complete guide to understanding the "Gatekeeper" psychology of modern parents.'
  }, {
    icon: <MessageCircleHeart className="w-6 h-6 text-brand-gold" data-id="element-110" />,
    title: 'The Low-Pressure Script Library',
    description: 'Word-for-word templates for birthdays, holidays, and "first contact" texts that bypass defensive walls.'
  }, {
    icon: <Activity className="w-6 h-6 text-brand-gold" data-id="element-111" />,
    title: 'The 7-Minute Nerve Reset',
    description: 'A physical sequence to stop your own "Send-Anxiety" and prevent desperate follow-up texts.'
  }, {
    icon: <Clock className="w-6 h-6 text-brand-gold" data-id="element-112" />,
    title: 'The 48-Hour No-Reply Protocol',
    description: 'Exactly what to do (and not do) when they ignore you—and how to handle it when they finally reply.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-brand-gold" data-id="element-113" />,
    title: 'The Trigger-Word Blacklist',
    description: 'The 5 specific words that accidentally trigger an adult child\'s "Block" reflex.'
  }];
  return <section className="py-20 bg-brand-sage relative" data-id="element-114">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-115">
        <div className="text-center mb-16" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-117">
            Everything You Need to Begin Rebuilding
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full opacity-50" data-id="element-118"></div>
        </div>

        <div className="space-y-6" data-id="element-119">
          {items.map((item, index) => <div key={index} className="bg-brand-cream rounded-2xl p-6 md:p-8 shadow-sm flex flex-col md:flex-row gap-6 items-start md:items-center transition-transform hover:-translate-y-1 duration-300" data-id="element-120">
              <div className="flex-shrink-0 w-14 h-14 rounded-full bg-brand-rose flex items-center justify-center" data-id="element-121">
                {item.icon}
              </div>
              <div data-id="element-122">
                <h3 className="text-xl font-bold mb-2" data-id="element-123">{item.title}</h3>
                <p className="text-brand-body leading-relaxed" data-id="element-124">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}